module.exports = __webpack_public_path__ + "img/wxewm.cc07603f.png";